export function useShopwareSwitchLocale() {
  const { localeProperties } = useI18n()
  const { apiClient } = useShopwareContext()

  function switchShopwareLocale() {
    const { shopwareLangId, shopwareAccessKey } = localeProperties.value

    const headers = {}

    if (shopwareLangId) {
      headers['sw-language-id'] = shopwareLangId
    } else {
      console.error('shopwareLangId is not defined')
    }

    if (shopwareAccessKey) {
      headers['sw-access-key'] = shopwareAccessKey
    } else {
      console.error('sw-access-key is not provided')
    }

    apiClient.defaultHeaders.apply(headers)

    // console.info('Shopware locale and access key switched', {
    //   shopwareLangId,
    // })
  }

  async function getAvailableLanguages() {
    return await useInternationalization().getAvailableLanguages()
  }

  const currentShopwareLanguageId = computed(() => {
    return localeProperties.value.shopwareLangId
  })

  // This is a shopware default value and it should never ever change, therefore we can hardcode it
  const defaultShopwareLanguageId = '2fbb5fe2e29a4d70aa5854ce7ce3e20b'

  return {
    currentShopwareLanguageId,
    defaultShopwareLanguageId,
    switchShopwareLocale,
    getAvailableLanguages,
  }
}
